/* import __COLOCATED_TEMPLATE__ from './new-comment.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();